var cov_5e7b717cg = function () {
  var path = "/Users/spana/SHEIN/shineout/src/EditableArea/EditableArea.tsx",
      hash = "1269be04ddb9350c95c08afd9054316343420da2",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/EditableArea/EditableArea.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 21
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 13
        },
        end: {
          line: 23,
          column: 21
        }
      },
      "2": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 38
        }
      },
      "3": {
        start: {
          line: 26,
          column: 29
        },
        end: {
          line: 26,
          column: 38
        }
      },
      "4": {
        start: {
          line: 27,
          column: 14
        },
        end: {
          line: 27,
          column: 39
        }
      },
      "5": {
        start: {
          line: 28,
          column: 14
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "6": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 29,
          column: 36
        }
      },
      "7": {
        start: {
          line: 29,
          column: 15
        },
        end: {
          line: 29,
          column: 36
        }
      },
      "8": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 30,
          column: 22
        }
      },
      "9": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 16
        }
      },
      "10": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 56,
          column: 5
        }
      },
      "11": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 65
        }
      },
      "12": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 57
        }
      },
      "13": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 50
        }
      },
      "14": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 50
        }
      },
      "15": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 56
        }
      },
      "16": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 44
        }
      },
      "17": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 40
        }
      },
      "18": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 46
        }
      },
      "19": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 50
        }
      },
      "20": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 59
        }
      },
      "21": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 60
        }
      },
      "22": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 51
        }
      },
      "23": {
        start: {
          line: 73,
          column: 29
        },
        end: {
          line: 73,
          column: 39
        }
      },
      "24": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 76,
          column: 5
        }
      },
      "25": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 22
        }
      },
      "26": {
        start: {
          line: 80,
          column: 25
        },
        end: {
          line: 80,
          column: 35
        }
      },
      "27": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 55
        }
      },
      "28": {
        start: {
          line: 81,
          column: 40
        },
        end: {
          line: 81,
          column: 55
        }
      },
      "29": {
        start: {
          line: 85,
          column: 36
        },
        end: {
          line: 85,
          column: 46
        }
      },
      "30": {
        start: {
          line: 86,
          column: 19
        },
        end: {
          line: 86,
          column: 47
        }
      },
      "31": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 18
        }
      },
      "32": {
        start: {
          line: 88,
          column: 19
        },
        end: {
          line: 88,
          column: 31
        }
      },
      "33": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 92,
          column: 5
        }
      },
      "34": {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 32
        }
      },
      "35": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 29
        }
      },
      "36": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 25
        }
      },
      "37": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 47
        }
      },
      "38": {
        start: {
          line: 94,
          column: 38
        },
        end: {
          line: 94,
          column: 47
        }
      },
      "39": {
        start: {
          line: 98,
          column: 21
        },
        end: {
          line: 98,
          column: 31
        }
      },
      "40": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 39
        }
      },
      "41": {
        start: {
          line: 99,
          column: 28
        },
        end: {
          line: 99,
          column: 39
        }
      },
      "42": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 53
        }
      },
      "43": {
        start: {
          line: 100,
          column: 35
        },
        end: {
          line: 100,
          column: 53
        }
      },
      "44": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 16
        }
      },
      "45": {
        start: {
          line: 105,
          column: 33
        },
        end: {
          line: 105,
          column: 35
        }
      },
      "46": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 57
        }
      },
      "47": {
        start: {
          line: 106,
          column: 31
        },
        end: {
          line: 106,
          column: 57
        }
      },
      "48": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 12
        }
      },
      "49": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "50": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 103
        }
      },
      "51": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 41
        }
      },
      "52": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 117,
          column: 5
        }
      },
      "53": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 43
        }
      },
      "54": {
        start: {
          line: 121,
          column: 24
        },
        end: {
          line: 121,
          column: 34
        }
      },
      "55": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 49
        }
      },
      "56": {
        start: {
          line: 122,
          column: 39
        },
        end: {
          line: 122,
          column: 49
        }
      },
      "57": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 19
        }
      },
      "58": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 130,
          column: 31
        }
      },
      "59": {
        start: {
          line: 130,
          column: 25
        },
        end: {
          line: 130,
          column: 31
        }
      },
      "60": {
        start: {
          line: 131,
          column: 19
        },
        end: {
          line: 133,
          column: 28
        }
      },
      "61": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 40
        }
      },
      "62": {
        start: {
          line: 134,
          column: 16
        },
        end: {
          line: 134,
          column: 40
        }
      },
      "63": {
        start: {
          line: 138,
          column: 29
        },
        end: {
          line: 138,
          column: 39
        }
      },
      "64": {
        start: {
          line: 139,
          column: 84
        },
        end: {
          line: 139,
          column: 94
        }
      },
      "65": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 34
        }
      },
      "66": {
        start: {
          line: 140,
          column: 23
        },
        end: {
          line: 140,
          column: 34
        }
      },
      "67": {
        start: {
          line: 141,
          column: 26
        },
        end: {
          line: 141,
          column: 52
        }
      },
      "68": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 160,
          column: 5
        }
      },
      "69": {
        start: {
          line: 164,
          column: 90
        },
        end: {
          line: 164,
          column: 100
        }
      },
      "70": {
        start: {
          line: 165,
          column: 19
        },
        end: {
          line: 165,
          column: 40
        }
      },
      "71": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 181,
          column: 5
        }
      },
      "72": {
        start: {
          line: 185,
          column: 69
        },
        end: {
          line: 185,
          column: 79
        }
      },
      "73": {
        start: {
          line: 186,
          column: 4
        },
        end: {
          line: 199,
          column: 5
        }
      },
      "74": {
        start: {
          line: 203,
          column: 29
        },
        end: {
          line: 203,
          column: 39
        }
      },
      "75": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 206,
          column: 5
        }
      },
      "76": {
        start: {
          line: 205,
          column: 6
        },
        end: {
          line: 205,
          column: 32
        }
      },
      "77": {
        start: {
          line: 207,
          column: 4
        },
        end: {
          line: 207,
          column: 29
        }
      },
      "78": {
        start: {
          line: 211,
          column: 29
        },
        end: {
          line: 211,
          column: 39
        }
      },
      "79": {
        start: {
          line: 212,
          column: 87
        },
        end: {
          line: 212,
          column: 97
        }
      },
      "80": {
        start: {
          line: 213,
          column: 16
        },
        end: {
          line: 213,
          column: 91
        }
      },
      "81": {
        start: {
          line: 214,
          column: 15
        },
        end: {
          line: 214,
          column: 46
        }
      },
      "82": {
        start: {
          line: 215,
          column: 21
        },
        end: {
          line: 215,
          column: 42
        }
      },
      "83": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 235,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 13
          },
          end: {
            line: 23,
            column: 14
          }
        },
        loc: {
          start: {
            line: 23,
            column: 19
          },
          end: {
            line: 23,
            column: 21
          }
        },
        line: 23
      },
      "1": {
        name: "formatShowValue",
        decl: {
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 25,
            column: 24
          }
        },
        loc: {
          start: {
            line: 25,
            column: 41
          },
          end: {
            line: 31,
            column: 1
          }
        },
        line: 25
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 32
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 52
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        },
        loc: {
          start: {
            line: 72,
            column: 74
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 72
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 26
          },
          end: {
            line: 82,
            column: 3
          }
        },
        line: 79
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        loc: {
          start: {
            line: 84,
            column: 30
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 84
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 3
          }
        },
        loc: {
          start: {
            line: 97,
            column: 12
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 97
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        },
        loc: {
          start: {
            line: 104,
            column: 18
          },
          end: {
            line: 108,
            column: 3
          }
        },
        line: 104
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 110,
            column: 2
          },
          end: {
            line: 110,
            column: 3
          }
        },
        loc: {
          start: {
            line: 110,
            column: 36
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 110
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 120,
            column: 2
          },
          end: {
            line: 120,
            column: 3
          }
        },
        loc: {
          start: {
            line: 120,
            column: 35
          },
          end: {
            line: 123,
            column: 3
          }
        },
        line: 120
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 125,
            column: 3
          }
        },
        loc: {
          start: {
            line: 125,
            column: 60
          },
          end: {
            line: 127,
            column: 3
          }
        },
        line: 125
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 129,
            column: 2
          },
          end: {
            line: 129,
            column: 3
          }
        },
        loc: {
          start: {
            line: 129,
            column: 14
          },
          end: {
            line: 135,
            column: 3
          }
        },
        line: 129
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 137,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        loc: {
          start: {
            line: 137,
            column: 19
          },
          end: {
            line: 161,
            column: 3
          }
        },
        line: 137
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 163,
            column: 2
          },
          end: {
            line: 163,
            column: 3
          }
        },
        loc: {
          start: {
            line: 163,
            column: 17
          },
          end: {
            line: 182,
            column: 3
          }
        },
        line: 163
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 184,
            column: 2
          },
          end: {
            line: 184,
            column: 3
          }
        },
        loc: {
          start: {
            line: 184,
            column: 16
          },
          end: {
            line: 200,
            column: 3
          }
        },
        line: 184
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 202,
            column: 2
          },
          end: {
            line: 202,
            column: 3
          }
        },
        loc: {
          start: {
            line: 202,
            column: 16
          },
          end: {
            line: 208,
            column: 3
          }
        },
        line: 202
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 210,
            column: 2
          },
          end: {
            line: 210,
            column: 3
          }
        },
        loc: {
          start: {
            line: 210,
            column: 11
          },
          end: {
            line: 236,
            column: 3
          }
        },
        line: 210
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 38
          }
        }, {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 38
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 12
          }
        }, {
          start: {
            line: 26,
            column: 16
          },
          end: {
            line: 26,
            column: 27
          }
        }],
        line: 26
      },
      "2": {
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 36
          }
        }, {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 36
          }
        }],
        line: 29
      },
      "3": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }],
        line: 74
      },
      "4": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 47
          }
        }, {
          start: {
            line: 74,
            column: 51
          },
          end: {
            line: 74,
            column: 63
          }
        }],
        line: 74
      },
      "5": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 55
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 55
          }
        }],
        line: 81
      },
      "6": {
        loc: {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        }, {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        }],
        line: 89
      },
      "7": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 47
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 47
          }
        }],
        line: 94
      },
      "8": {
        loc: {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 99,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 99,
            column: 39
          }
        }, {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 99,
            column: 39
          }
        }],
        line: 99
      },
      "9": {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 53
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 53
          }
        }],
        line: 100
      },
      "10": {
        loc: {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 106,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 106,
            column: 57
          }
        }, {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 106,
            column: 57
          }
        }],
        line: 106
      },
      "11": {
        loc: {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }, {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }],
        line: 111
      },
      "12": {
        loc: {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 111,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 111,
            column: 12
          }
        }, {
          start: {
            line: 111,
            column: 16
          },
          end: {
            line: 111,
            column: 26
          }
        }],
        line: 111
      },
      "13": {
        loc: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        }, {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        }],
        line: 115
      },
      "14": {
        loc: {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 49
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 49
          }
        }],
        line: 122
      },
      "15": {
        loc: {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 130,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 130,
            column: 31
          }
        }, {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 130,
            column: 31
          }
        }],
        line: 130
      },
      "16": {
        loc: {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 40
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 40
          }
        }],
        line: 134
      },
      "17": {
        loc: {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 34
          }
        }, {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 34
          }
        }],
        line: 140
      },
      "18": {
        loc: {
          start: {
            line: 168,
            column: 18
          },
          end: {
            line: 168,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 168,
            column: 29
          },
          end: {
            line: 168,
            column: 38
          }
        }, {
          start: {
            line: 168,
            column: 41
          },
          end: {
            line: 168,
            column: 42
          }
        }],
        line: 168
      },
      "19": {
        loc: {
          start: {
            line: 169,
            column: 74
          },
          end: {
            line: 169,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 169,
            column: 74
          },
          end: {
            line: 169,
            column: 79
          }
        }, {
          start: {
            line: 169,
            column: 83
          },
          end: {
            line: 169,
            column: 92
          }
        }],
        line: 169
      },
      "20": {
        loc: {
          start: {
            line: 169,
            column: 94
          },
          end: {
            line: 169,
            column: 116
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 169,
            column: 94
          },
          end: {
            line: 169,
            column: 102
          }
        }, {
          start: {
            line: 169,
            column: 106
          },
          end: {
            line: 169,
            column: 116
          }
        }],
        line: 169
      },
      "21": {
        loc: {
          start: {
            line: 174,
            column: 55
          },
          end: {
            line: 174,
            column: 103
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 174,
            column: 55
          },
          end: {
            line: 174,
            column: 65
          }
        }, {
          start: {
            line: 174,
            column: 69
          },
          end: {
            line: 174,
            column: 103
          }
        }],
        line: 174
      },
      "22": {
        loc: {
          start: {
            line: 177,
            column: 13
          },
          end: {
            line: 177,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 13
          },
          end: {
            line: 177,
            column: 19
          }
        }, {
          start: {
            line: 177,
            column: 23
          },
          end: {
            line: 177,
            column: 95
          }
        }],
        line: 177
      },
      "23": {
        loc: {
          start: {
            line: 177,
            column: 67
          },
          end: {
            line: 177,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 67
          },
          end: {
            line: 177,
            column: 78
          }
        }, {
          start: {
            line: 177,
            column: 82
          },
          end: {
            line: 177,
            column: 88
          }
        }],
        line: 177
      },
      "24": {
        loc: {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 206,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 206,
            column: 5
          }
        }, {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 206,
            column: 5
          }
        }],
        line: 204
      },
      "25": {
        loc: {
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 204,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 204,
            column: 20
          }
        }, {
          start: {
            line: 204,
            column: 24
          },
          end: {
            line: 204,
            column: 58
          }
        }],
        line: 204
      },
      "26": {
        loc: {
          start: {
            line: 213,
            column: 61
          },
          end: {
            line: 213,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 213,
            column: 61
          },
          end: {
            line: 213,
            column: 70
          }
        }, {
          start: {
            line: 213,
            column: 74
          },
          end: {
            line: 213,
            column: 89
          }
        }],
        line: 213
      },
      "27": {
        loc: {
          start: {
            line: 229,
            column: 9
          },
          end: {
            line: 233,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 230,
            column: 10
          },
          end: {
            line: 232,
            column: 16
          }
        }, {
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 233,
            column: 16
          }
        }],
        line: 229
      },
      "28": {
        loc: {
          start: {
            line: 229,
            column: 9
          },
          end: {
            line: 229,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 229,
            column: 9
          },
          end: {
            line: 229,
            column: 18
          }
        }, {
          start: {
            line: 229,
            column: 22
          },
          end: {
            line: 229,
            column: 27
          }
        }],
        line: 229
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/EditableArea/EditableArea.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import config from '../config';
import Textarea from '../Textarea';
import Input from '../Input';
import Popover from '../Popover';
import { editableAreaClass } from './styles';
import icons from '../icons';
import { focusElement, getParent } from '../utils/dom/element';
import { inputClass } from '../Input/styles';
import InputTitle from '../InputTitle';
import { inputTitleClass } from '../InputTitle/styles';
var DefaultProps = (cov_5e7b717cg.s[0]++, {
  bordered: false
});
cov_5e7b717cg.s[1]++;

var noop = function noop() {
  cov_5e7b717cg.f[0]++;
};

function formatShowValue(value) {
  cov_5e7b717cg.f[1]++;
  cov_5e7b717cg.s[2]++;

  if ((cov_5e7b717cg.b[1][0]++, !value) && (cov_5e7b717cg.b[1][1]++, value !== 0)) {
    cov_5e7b717cg.b[0][0]++;
    cov_5e7b717cg.s[3]++;
    return '';
  } else {
    cov_5e7b717cg.b[0][1]++;
  }

  var arr = (cov_5e7b717cg.s[4]++, String(value).split('\n'));
  var len = (cov_5e7b717cg.s[5]++, arr.length);
  cov_5e7b717cg.s[6]++;

  if (len > 1) {
    cov_5e7b717cg.b[2][0]++;
    cov_5e7b717cg.s[7]++;
    return "".concat(arr[0], "...");
  } else {
    cov_5e7b717cg.b[2][1]++;
  }

  cov_5e7b717cg.s[8]++;
  return String(value);
}

var Editable =
/*#__PURE__*/
function (_ref) {
  _inherits(Editable, _ref);

  var _super = _createSuper2(Editable);

  function Editable(props) {
    var _this;

    _classCallCheck(this, Editable);

    cov_5e7b717cg.f[2]++;
    cov_5e7b717cg.s[9]++;
    _this = _super.call(this, props);
    _this.bindContainer = void 0;
    _this.bindInput = void 0;
    _this.container = void 0;
    _this.input = void 0;
    _this.showPop = void 0;
    _this.hidePop = void 0;
    _this.handleClear = void 0;
    _this.width = void 0;
    cov_5e7b717cg.s[10]++;
    _this.state = {
      showTextarea: false
    };
    cov_5e7b717cg.s[11]++;
    _this.bindContainer = _this.bindElement.bind(_assertThisInitialized(_this), 'container');
    cov_5e7b717cg.s[12]++;
    _this.bindInput = _this.bindElement.bind(_assertThisInitialized(_this), 'input');
    cov_5e7b717cg.s[13]++;
    _this.renderInput = _this.renderInput.bind(_assertThisInitialized(_this));
    cov_5e7b717cg.s[14]++;
    _this.renderPlace = _this.renderPlace.bind(_assertThisInitialized(_this));
    cov_5e7b717cg.s[15]++;
    _this.renderTextarea = _this.renderTextarea.bind(_assertThisInitialized(_this));
    cov_5e7b717cg.s[16]++;
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    cov_5e7b717cg.s[17]++;
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    cov_5e7b717cg.s[18]++;
    _this.autoFocus = _this.autoFocus.bind(_assertThisInitialized(_this));
    cov_5e7b717cg.s[19]++;
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    cov_5e7b717cg.s[20]++;
    _this.showPop = _this.updateShowTextarea.bind(_assertThisInitialized(_this), true);
    cov_5e7b717cg.s[21]++;
    _this.hidePop = _this.updateShowTextarea.bind(_assertThisInitialized(_this), false);
    cov_5e7b717cg.s[22]++;
    _this.handleClear = _this.onChange.bind(_assertThisInitialized(_this), '');
    return _this;
  }

  _createClass(Editable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      cov_5e7b717cg.f[3]++;

      var _ref2 = (cov_5e7b717cg.s[23]++, this.state),
          showTextarea = _ref2.showTextarea;

      cov_5e7b717cg.s[24]++;

      if ((cov_5e7b717cg.b[4][0]++, prevState.showTextarea !== showTextarea) && (cov_5e7b717cg.b[4][1]++, showTextarea)) {
        cov_5e7b717cg.b[3][0]++;
        cov_5e7b717cg.s[25]++;
        this.autoFocus();
      } else {
        cov_5e7b717cg.b[3][1]++;
      }
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      cov_5e7b717cg.f[4]++;

      var _ref3 = (cov_5e7b717cg.s[26]++, this.props),
          onChange = _ref3.onChange;

      cov_5e7b717cg.s[27]++;

      if (typeof onChange === 'function') {
        cov_5e7b717cg.b[5][0]++;
        cov_5e7b717cg.s[28]++;
        onChange(value);
      } else {
        cov_5e7b717cg.b[5][1]++;
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      cov_5e7b717cg.f[5]++;

      var _ref4 = (cov_5e7b717cg.s[29]++, this.props),
          onBlur = _ref4.onBlur,
          forceChange = _ref4.forceChange;

      var target = (cov_5e7b717cg.s[30]++, e.target);
      cov_5e7b717cg.s[31]++;
      this.hidePop();
      var newValue = (cov_5e7b717cg.s[32]++, target.value);
      cov_5e7b717cg.s[33]++;

      if (this.getTrim()) {
        cov_5e7b717cg.b[6][0]++;
        cov_5e7b717cg.s[34]++;
        newValue = newValue.trim();
        cov_5e7b717cg.s[35]++;
        target.value = newValue;
      } else {
        cov_5e7b717cg.b[6][1]++;
      }

      cov_5e7b717cg.s[36]++;
      forceChange(newValue);
      cov_5e7b717cg.s[37]++;

      if (typeof onBlur === 'function') {
        cov_5e7b717cg.b[7][0]++;
        cov_5e7b717cg.s[38]++;
        onBlur(e);
      } else {
        cov_5e7b717cg.b[7][1]++;
      }
    }
  }, {
    key: "getTrim",
    value: function getTrim() {
      cov_5e7b717cg.f[6]++;

      var _ref5 = (cov_5e7b717cg.s[39]++, this.props),
          trim = _ref5.trim;

      cov_5e7b717cg.s[40]++;

      if (trim !== undefined) {
        cov_5e7b717cg.b[8][0]++;
        cov_5e7b717cg.s[41]++;
        return trim;
      } else {
        cov_5e7b717cg.b[8][1]++;
      }

      cov_5e7b717cg.s[42]++;

      if (config.trim !== undefined) {
        cov_5e7b717cg.b[9][0]++;
        cov_5e7b717cg.s[43]++;
        return config.trim;
      } else {
        cov_5e7b717cg.b[9][1]++;
      }

      cov_5e7b717cg.s[44]++;
      return false;
    }
  }, {
    key: "getErrorProps",
    value: function getErrorProps() {
      cov_5e7b717cg.f[7]++;
      var p = (cov_5e7b717cg.s[45]++, {});
      cov_5e7b717cg.s[46]++;

      if ('error' in this.props) {
        cov_5e7b717cg.b[10][0]++;
        cov_5e7b717cg.s[47]++;
        p.error = this.props.error;
      } else {
        cov_5e7b717cg.b[10][1]++;
      }

      cov_5e7b717cg.s[48]++;
      return p;
    }
  }, {
    key: "updateShowTextarea",
    value: function updateShowTextarea(flag) {
      cov_5e7b717cg.f[8]++;
      cov_5e7b717cg.s[49]++;

      if ((cov_5e7b717cg.b[12][0]++, flag) && (cov_5e7b717cg.b[12][1]++, this.input)) {
        cov_5e7b717cg.b[11][0]++;
        cov_5e7b717cg.s[50]++;
        this.width = getParent(this.input, ".".concat(editableAreaClass('input'))).offsetWidth;
      } else {
        cov_5e7b717cg.b[11][1]++;
      }

      cov_5e7b717cg.s[51]++;
      this.setState({
        showTextarea: flag
      });
      cov_5e7b717cg.s[52]++;

      if (this.props.onShowTextareaChange) {
        cov_5e7b717cg.b[13][0]++;
        cov_5e7b717cg.s[53]++;
        this.props.onShowTextareaChange(flag);
      } else {
        cov_5e7b717cg.b[13][1]++;
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      cov_5e7b717cg.f[9]++;

      var _ref6 = (cov_5e7b717cg.s[54]++, this.props),
          onFocus = _ref6.onFocus;

      cov_5e7b717cg.s[55]++;

      if (typeof onFocus === 'function') {
        cov_5e7b717cg.b[14][0]++;
        cov_5e7b717cg.s[56]++;
        onFocus(e);
      } else {
        cov_5e7b717cg.b[14][1]++;
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(type, el) {
      cov_5e7b717cg.f[10]++;
      cov_5e7b717cg.s[57]++;
      this[type] = el;
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      cov_5e7b717cg.f[11]++;
      cov_5e7b717cg.s[58]++;

      if (!this.container) {
        cov_5e7b717cg.b[15][0]++;
        cov_5e7b717cg.s[59]++;
        return;
      } else {
        cov_5e7b717cg.b[15][1]++;
      }

      var target = (cov_5e7b717cg.s[60]++, this.container.querySelector(".".concat(editableAreaClass('text-area'), " textarea.so-input-auto-size")));
      cov_5e7b717cg.s[61]++;

      if (target) {
        cov_5e7b717cg.b[16][0]++;
        cov_5e7b717cg.s[62]++;
        focusElement.end(target);
      } else {
        cov_5e7b717cg.b[16][1]++;
      }
    }
  }, {
    key: "renderTextarea",
    value: function renderTextarea() {
      cov_5e7b717cg.f[12]++;

      var _ref7 = (cov_5e7b717cg.s[63]++, this.state),
          showTextarea = _ref7.showTextarea;

      var _ref8 = (cov_5e7b717cg.s[64]++, this.props),
          placeholder = _ref8.placeholder,
          maxHeight = _ref8.maxHeight,
          value = _ref8.value,
          innerTitle = _ref8.innerTitle,
          placeTitle = _ref8.placeTitle,
          renderFooter = _ref8.renderFooter;

      cov_5e7b717cg.s[65]++;

      if (!showTextarea) {
        cov_5e7b717cg.b[17][0]++;
        cov_5e7b717cg.s[66]++;
        return null;
      } else {
        cov_5e7b717cg.b[17][1]++;
      }

      var addTitleProps = (cov_5e7b717cg.s[67]++, {
        innerTitle: innerTitle,
        placeTitle: placeTitle
      });
      cov_5e7b717cg.s[68]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindContainer,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 143,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Textarea, Object.assign({
          className: editableAreaClass('text-area'),
          autosize: true
        }, addTitleProps, {
          value: value,
          rows: 1,
          delay: 0,
          onChange: this.onChange,
          onBlur: this.onBlur,
          onFocus: this.handleFocus,
          placeholder: placeholder,
          maxHeight: maxHeight,
          renderFooter: renderFooter
        }, this.getErrorProps(), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 144,
            columnNumber: 9
          }
        })))
      );
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      cov_5e7b717cg.f[13]++;

      var _ref9 = (cov_5e7b717cg.s[69]++, this.props),
          placeholder = _ref9.placeholder,
          disabled = _ref9.disabled,
          value = _ref9.value,
          renderResult = _ref9.renderResult,
          placeTitle = _ref9.placeTitle,
          innerTitle = _ref9.innerTitle,
          error = _ref9.error;

      var result = (cov_5e7b717cg.s[70]++, renderResult(value));
      cov_5e7b717cg.s[71]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          tabIndex: disabled ? (cov_5e7b717cg.b[18][0]++, undefined) : (cov_5e7b717cg.b[18][1]++, 0),
          className: classnames(editableAreaClass('input'), inputClass('_', (cov_5e7b717cg.b[19][0]++, error) && (cov_5e7b717cg.b[19][1]++, 'invalid'), (cov_5e7b717cg.b[20][0]++, disabled) && (cov_5e7b717cg.b[20][1]++, 'disabled'))),
          onFocus: this.showPop,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 167,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(InputTitle, {
          placeTitle: placeTitle,
          innerTitle: innerTitle,
          open: !!value,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 172,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(inputClass('spare'), (cov_5e7b717cg.b[21][0]++, innerTitle) && (cov_5e7b717cg.b[21][1]++, inputTitleClass('hidable', 'item'))),
          ref: this.bindInput,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 173,
            columnNumber: 11
          }
        }, (cov_5e7b717cg.b[22][0]++, result) || (cov_5e7b717cg.b[22][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: inputClass('placeholder'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 177,
            columnNumber: 24
          }
        }, (cov_5e7b717cg.b[23][0]++, placeholder) || (cov_5e7b717cg.b[23][1]++,
        /*#__PURE__*/
        React.createElement("br", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 177,
            columnNumber: 83
          }
        })))))))
      );
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      cov_5e7b717cg.f[14]++;

      var _ref10 = (cov_5e7b717cg.s[72]++, this.props),
          placeholder = _ref10.placeholder,
          disabled = _ref10.disabled,
          value = _ref10.value,
          innerTitle = _ref10.innerTitle,
          placeTitle = _ref10.placeTitle;

      cov_5e7b717cg.s[73]++;
      return (
        /*#__PURE__*/
        React.createElement(Input, Object.assign({
          innerTitle: innerTitle,
          placeTitle: placeTitle,
          forwardedRef: this.bindInput,
          placeholder: placeholder,
          value: formatShowValue(value),
          onChange: noop,
          className: editableAreaClass('input'),
          onFocus: this.showPop,
          disabled: disabled
        }, this.getErrorProps(), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 187,
            columnNumber: 7
          }
        }))
      );
    }
  }, {
    key: "renderPlace",
    value: function renderPlace() {
      cov_5e7b717cg.f[15]++;

      var _ref11 = (cov_5e7b717cg.s[74]++, this.props),
          renderResult = _ref11.renderResult;

      cov_5e7b717cg.s[75]++;

      if ((cov_5e7b717cg.b[25][0]++, renderResult) && (cov_5e7b717cg.b[25][1]++, typeof renderResult === 'function')) {
        cov_5e7b717cg.b[24][0]++;
        cov_5e7b717cg.s[76]++;
        return this.renderResult();
      } else {
        cov_5e7b717cg.b[24][1]++;
      }

      cov_5e7b717cg.s[77]++;
      return this.renderInput();
    }
  }, {
    key: "render",
    value: function render() {
      cov_5e7b717cg.f[16]++;

      var _ref12 = (cov_5e7b717cg.s[78]++, this.state),
          showTextarea = _ref12.showTextarea;

      var _ref13 = (cov_5e7b717cg.s[79]++, this.props),
          width = _ref13.width,
          style = _ref13.style,
          className = _ref13.className,
          bordered = _ref13.bordered,
          clearable = _ref13.clearable,
          getPopupContainer = _ref13.getPopupContainer,
          value = _ref13.value;

      var cls = (cov_5e7b717cg.s[80]++, classnames(className, editableAreaClass('_', (cov_5e7b717cg.b[26][0]++, !bordered) && (cov_5e7b717cg.b[26][1]++, 'none-bordered'))));
      var ms = (cov_5e7b717cg.s[81]++, Object.assign({
        width: width
      }, style));
      var popStyle = (cov_5e7b717cg.s[82]++, {
        width: this.width
      });
      cov_5e7b717cg.s[83]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: cls,
          style: ms,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 217,
            columnNumber: 7
          }
        }, this.renderPlace(),
        /*#__PURE__*/
        React.createElement(Popover, {
          visible: showTextarea,
          showArrow: false,
          className: editableAreaClass('popover'),
          position: "cover",
          style: popStyle,
          getPopupContainer: getPopupContainer,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 219,
            columnNumber: 9
          }
        }, this.renderTextarea()), (cov_5e7b717cg.b[28][0]++, clearable) && (cov_5e7b717cg.b[28][1]++, value) ? (cov_5e7b717cg.b[27][0]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: editableAreaClass('clear'),
          onClick: this.handleClear,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 230,
            columnNumber: 11
          }
        }, icons.CloseCircle)) : (cov_5e7b717cg.b[27][1]++, null))
      );
    }
  }]);

  return Editable;
}((React.PureComponent));

Editable.defaultProps = DefaultProps;
export default Editable;